import { window } from '../window.js';
import { HTMLControl } from './html_control.js';

/**
 * Image mosaic.
 */
class ImageMosaic extends HTMLControl {
  static selectors = {
    ImageAt(index) {
      return `img:nth-of-type(${index + 1})`;
    },
  };

  static properties = {
    inactive: {
      attribute: 'boolean',
    },
    // Sets a picture list consisting of { url, alt }.
    setPics(list) {
      this.#setPics(list);
    },
  };

  constructor() {
    super();
    this.addEventListener('click', ev => {
      if (this.inactive) {
        return;
      }
      let cell = ev.target.closest('.image-mosaic-grid-cell');
      if (cell) {
        let idx = 0;
        while ((cell = cell.previousElementSibling)) {
          idx++;
        }
        this.dispatchEvent(
          new CustomEvent('picpick', {
            detail: idx,
          })
        );
      }
    });
  }

  initialize() {
    super.initialize();

    let picEls = Array.from(this.querySelectorAll('image-mosaic-pic'));

    this.innerHTML = `<div class='image-mosaic-grid'></div>`;
    this.gridElement = this.firstElementChild;

    if (picEls.length) {
      this.#setPics(
        picEls.map(el => ({
          url: el.getAttribute('src'),
          alt: el.getAttribute('alt'),
        }))
      );
    }
  }

  #setPics(list) {
    let len = Math.min(list.length, 4);

    let markup = '';
    for (let i = 0; i < len; i++) {
      let altAttr = list[i].alt ? ` alt='${list[i].alt}'` : '';
      if (i == len - 1 && list.length > len) {
        markup += `<div class='image-mosaic-grid-cell image-mosaic-grid-cell-morepics'>
          <div class='image-mosaic-morepics-container'>
            <div class='image-mosaic-morepics-number'>+${list.length - 4}</div>
          </div>
          <img src='${list[i].url}'${altAttr}>
        </div>`;
      } else {
        markup += `<img class='image-mosaic-grid-cell' src='${list[i].url}'${altAttr}>`;
      }
    }

    let gridcn = `image-mosaic-grid-${len}pics`;
    this.gridElement.className = `image-mosaic-grid ${gridcn}`;
    this.gridElement.innerHTML = markup;
  }
}

window.customElements.define('image-mosaic', ImageMosaic);

export { ImageMosaic };
